import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useCookies } from 'react-cookie';
import { CookieRedirect } from 'components/utils/helpers';
import Terms from 'components/modules/Terms';
import Privacy from 'components/modules/Privacy';
// Images
import Logo from 'svg/logo';

/**
 * The Intro
 *
 * Ask the user if they are over 13,
 * then show some intro animations
 */
const AgeGate = (props) => {
  // Redirect if user is too young
  CookieRedirect();
  // History state and cookies
  const history = useHistory();
  // eslint-disable-next-line
  const [cookie, setCookie] = useCookies(['tooYoung', 'loggedIn', 'hasSeenIntro']);
  // State
  const [showPrivacy, setShowPrivacy] = useState(false);
  const [showTerms, setShowTerms] = useState(false);

  /**
   * Banish to age gate screen if under 13
   */
  const runUnderThirteen = () => {
    setCookie('tooYoung', true, { path: '/' });
    history.push('/not-available');
  };

  /**
   * Over thirteen – send to intro
   */
  const runOverThirteen = () => {
    setCookie('tooYoung', false, { path: '/' });
    history.push('/intro');
  }

  /**
   * Toggle privacy screen
   */
  const togglePrivacy = () => {
    if (!showPrivacy) {
      setShowPrivacy(true);
    } else {
      setShowPrivacy(false);
    }
  }

  /**
   * Toggle terms screen
   */
  const toggleTerms = () => {
    if (!showTerms) {
      setShowTerms(true);
    } else {
      setShowTerms(false);
    }
  }

  return (
    <article className='Intro'>
      <Logo className='Intro__logo' />
      <div className='Intro__inner'>
        <section className='Intro__age-gate'>
          <h3 className='Intro__text'>Select your age range</h3>
          <div className='Intro__button-wrapper'>
            <button className='button Intro__button' onClick={runUnderThirteen}>0 - 8</button>
            <button className='button Intro__button' onClick={runUnderThirteen}>9 - 12</button>
            <button className='button Intro__button' onClick={runOverThirteen}>13 - 17</button>
            <button className='button Intro__button' onClick={runOverThirteen}>18 - 24</button>
            <button className='button Intro__button' onClick={runOverThirteen}>25+</button>
          </div>
        </section>
      </div>
      <div className='Intro__moreinfo'>
        <a href='https://contactus.generalmills.com/?page=http://www.generalmills.com' target='_blank' rel='noopener noreferrer' className='Intro__moreinfo-links'>Contact Us</a>
        <a href='https://www.generalmills.com/en/Company/privacy-policies/privacy-policy-cookie-US-English' target='_blank' rel='noopener noreferrer' className='Intro__moreinfo-links'>Privacy Policy</a>
        <a href='https://www.generalmills.com/en/Company/legal-terms' target='_blank' rel='noopener noreferrer' className='Intro__moreinfo-links'>Legal Terms</a>
      </div>
      {showPrivacy && (
        <Privacy closeAction={togglePrivacy} />
      )}
      {showTerms && (
        <Terms closeAction={toggleTerms} />
      )}
    </article>
  )
};

export default AgeGate;
